<template>
  <!-- Preview invoice to download pdf -->
  <v-container style="height: 100%;" class="scroll-y bg-white">
    <open-billing-invoice-preview
      v-for="(invoice, index) in invoices"
      id="element-to-print"
      :key="index"
      class="bg-white"
      :logo="invoiceLogo"
      :invoice="invoice.invoice"
      :invoice-type="invoiceType"
      :totalInvoiceData="invoice.totalData"
      :items-tax="invoice.itemsTax"
      :selected-taxes="invoice.selectedTaxes"
      :total-suplidos="invoice.totalSuplidos"
    ></open-billing-invoice-preview>
  </v-container>
</template>

<script>
import OpenBillingInvoicePreview from '@/modules/openbilling/components/OpenBillingInvoicePreview';

export default {
  name: 'OpenBillingGenerateInvoicePdf',
  components: {
    'open-billing-invoice-preview': OpenBillingInvoicePreview,
  },
  props: ['invoices', 'invoiceType', 'invoiceLogo'],
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style scoped>
.bg-white {
  background-color: white;
}
</style>
